import React from "react";
import { useDispatch } from "react-redux";
import "../RoleName/RoleName.css";
import "../OptionBlocks.css";
import {
  BalanceOff,
  BalanceCenter,
  ColumnHorizontal,
  ColumnVertical,
  GutterAlignment,
  JustifiedAlignment3,
  LeftAlignment2,
  RaggedAlignment,
  RightAlignment2,
  SideAB,
  InsetOff,
  InsetLeft,
  InsetRight,
  SingleColumnCenter,
  SingleColumnLeft,
  SingleColumnRight,
} from "../../../../../assets/icons/index";
import { NumberInput, Radio, Dropdown } from "../../../../../Components";
import {
  updateProjectCreditOptionsState,
  saveOptionById,
} from "../../../../../Redux/actions/projectActions";

import {
  Heading,
  Subheading,
} from "../../../../ProjectV2/Options/OptionFont/Functions";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
const initialOptions = [
  { label: "None", value: 0 },
  { label: "10%", value: 10 },
  { label: "20%", value: 20 },
  { label: "30%", value: 30 },
  { label: "40%", value: 40 },
  { label: "50%", value: 50 },
];
const Blurb = ({ options, currentBlockIdx, currentBlockId, isCard }) => {
  const dispatch = useDispatch();
  const [selectedID, setSelectedID] = useState("");
  const location = useLocation();
  const [option, setOptions] = useState([...initialOptions]);
  const handleChange = (key, val) => {
    dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, val));
  };

  const saveOptions = () => dispatch(saveOptionById(currentBlockId, isCard));

  const getValue = (value) => {
    return value ? value : "";
  };
  useEffect(() => {
    const idx = option.findIndex(
      (opt) => opt.value === options?.margin_vertical
    );
    console.log("margin_vertical", options?.margin_vertical, "idx", idx);
    if (idx !== -1) {
      setSelectedID(idx);
    }
  }, [options?.margin_vertical]);

  return (
    <div className="Roles-name">
      <div className="rolename-inside">
        <div className="optionSection">
          <div className="optionSectionLabel">Heading</div>
          <div className="optionSectionContent heading_padding">
            <Heading
              onChange={(val) => {
                handleChange("heading", val);
              }}
              value={getValue(options.heading)}
              onFocusOut={saveOptions}
            />
          </div>
        </div>
        <div className="optionSection">
          <div className="optionSectionLabel">Sub-Heading</div>
          <div className="optionSectionContent heading_padding">
            <Subheading
              onChange={(val) => {
                handleChange("subheading", val);
              }}
              value={getValue(options.subheading ? options.subheading : "")}
              onFocusOut={saveOptions}
            />
          </div>
        </div>
        <div className="optionSection">
          <div className="optionSectionLabel">Alignment</div>
          <div className="optionSectionContent">
            <Radio
              options={[
                { icon: SingleColumnCenter, value: "center" },
                { icon: SingleColumnLeft, value: "left" },
                { icon: SingleColumnRight, value: "right" },
                { icon: JustifiedAlignment3, value: "justify", disabled: true },
                { icon: GutterAlignment, value: "gutter", disabled: true },
              ]}
              value={options.text_alignment}
              onChange={(val) => {
                handleChange("text_alignment", val);
                saveOptions();
              }}
              label={options.text_alignment}
              withIcon
            />
          </div>
        </div>

        <div className="optionSection">
          <div className="optionSectionLabel">Column</div>
          <div className="optionSectionContent">
            <NumberInput
              postLabel="%"
              label="Width"
              value={options.column_width}
              onChange={(val) => handleChange("column_width", val)}
              min={20}
              max={100}
              onFocusOut={saveOptions}
            />
          </div>
        </div>

        {/* <div className="optionSection">
          <div className="optionSectionContent2">
            <Radio
              options={[
                { icon: BalanceOff, value: null },
                { icon: BalanceCenter, value: "center" },
              ]}
              value={options.balance_columns}
              onChange={(val) => {
                handleChange("balance_columns", val);
                saveOptions();
              }}
              withIcon
              label="Balance"
            />
          </div>
        </div> */}
        {/* <div className="optionSection">
          <div className="optionSectionLabel">Order</div>
          <div className="optionSectionContent">
            <Radio
              options={[
                { icon: ColumnHorizontal, value: "horizontal" },
                { icon: ColumnVertical, value: "vertical" },
              ]}
              value={options.column_flow}
              onChange={(val) => {
                handleChange("column_flow", val);
                saveOptions();
              }}
              label="Column flow"
              withIcon
            />
          </div>
        </div> */}
        {/* <hr className="border-b-2 border-white/[.6]" /> */}
        <div className="optionSection">
          <div className="optionSectionLabel">Block Inset</div>
          <div className="optionSectionContent BLock-inset BLock-inset-nameonly">
            <Radio
              label={options.block_inset}
              //  options={[
              //   {
              //     icon: InsetOff, value: "default",
              //     disabled: (options?.side_by_side === "on" && (options?.block_inset === "default" || options?.block_inset === "left" || options?.block_inset === "right"))
              //   },
              //   { icon: InsetLeft, value: "left" },
              //   { icon: InsetRight, value: "right" },
              //   { icon: SideAB, value: "sidebyside", disabled: options?.side_by_side === "on" },
              // ]}
              options={[
                {
                  icon: InsetOff,
                  value: "default",
                  disabled:
                    options?.side_by_side === "on" &&
                    (options?.block_inset === "default" ||
                      options?.block_inset === "left" ||
                      options?.block_inset === "right"),
                },
                {
                  icon: InsetLeft,
                  value: "left",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: InsetRight,
                  value: "right",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: SideAB,
                  value: "sidebyside",
                  disabled: options?.side_by_side === "on",
                },
              ]}
              value={options.block_inset}
              onChange={(val) => {
                handleChange("block_inset", val);
                saveOptions();
              }}
              withIcon
            />
          </div>
        </div>
        {!isCard && (
          <div>
            <div className="optionSection">
              <div className="optionSectionLabel">Margin</div>
              <div className="optionSectionContent block-option-content">
                <div className="label-2 label-2-roleName1440">Vertical</div>
                <Dropdown
                  // label="Vertical"
                  options={option}
                  selectedID={selectedID}
                  value={options.margin_vertical}
                  onChange={(val) => {
                    handleChange("margin_vertical", val);
                    saveOptions();
                  }}
                />
              </div>
            </div>

            <div className="optionSection">
              <div className="optionSectionContent2 block-option-content">
                <div className="label-1">Bottom</div>
                <NumberInput
                  // label="Bottom"
                  value={options.extra_lines_below}
                  min={0}
                  max={25}
                  onChange={(val) => handleChange("extra_lines_below", val)}
                  onFocusOut={saveOptions}
                />
              </div>
            </div>
          </div>
        )}
        {isCard && <div></div>}
      </div>
    </div>
  );
};

export default Blurb;
